import React from "react";
import { AppHubHero } from "./AppHubHero.jsx";
import { AppHubSecondaryNav } from "./AppHubSecondaryNav.jsx";

/**
 * Gemeinsames Übersichts-Seitenmuster: Hero → Secondary → Content → Footer.
 * @param {{
 *   hero: React.ComponentProps<typeof AppHubHero>,
 *   secondary?: React.ComponentProps<typeof AppHubSecondaryNav> | null,
 *   children: React.ReactNode,
 *   footerTagline?: string,
 *   banner?: React.ReactNode,
 * }} props
 */
export function AppHubShell({
  hero,
  secondary = null,
  children,
  footerTagline = "",
  banner = null,
}) {
  return (
    <div className="mm-hub__dashboard">
      {banner}
      <AppHubHero {...hero} />
      {secondary ? <AppHubSecondaryNav {...secondary} /> : null}
      {children}
      {footerTagline ? (
        <p className="mm-hub__footerTagline muted">{footerTagline}</p>
      ) : null}
    </div>
  );
}
